const queries = [
  "front-end-development",
  "photography",
  "back-end-development",
  "videography",
  "full-stack-development",
  "graphic-design",
  "android-development",
  "digital-animation",
  "ios-development",
  "web-design",
  "software-engineering",
];

export default queries;
